import { jsxs as s, jsx as e, Fragment as l } from "react/jsx-runtime";
import i from "./productDetails.module.js";
import { useTranslation as I } from "../../hooks/useTranslation.js";
const j = ({
  productData: n,
  className: _,
  brandLinkComponent: m,
  subBrandLinkComponent: h,
  withoutCodes: b,
  withoutBrandNames: f
}) => {
  const { t: v } = I();
  return /* @__PURE__ */ s("div", { className: _, children: [
    f ? null : /* @__PURE__ */ e(l, { children: ((n == null ? void 0 : n.brand_name) || (n == null ? void 0 : n.sub_brand_name)) && /* @__PURE__ */ s(l, { children: [
      /* @__PURE__ */ e("span", { children: v("brand_name") }),
      /* @__PURE__ */ s("div", { className: i.productDetailsInfo, children: [
        m || /* @__PURE__ */ e(l, { children: (n == null ? void 0 : n.brand_name) && /* @__PURE__ */ e("span", { children: n == null ? void 0 : n.brand_name }) }),
        h || /* @__PURE__ */ e(l, { children: (n == null ? void 0 : n.sub_brand_name) && /* @__PURE__ */ e("span", { children: n == null ? void 0 : n.sub_brand_name }) })
      ] })
    ] }) }),
    b ? null : /* @__PURE__ */ s(l, { children: [
      /* @__PURE__ */ e("span", { children: "GTIN" }),
      /* @__PURE__ */ e("div", { className: i.productDetailsInfo, children: n == null ? void 0 : n.gtin }),
      /* @__PURE__ */ e("span", { children: "SAP" }),
      /* @__PURE__ */ e("div", { className: i.productDetailsInfo, children: n == null ? void 0 : n.sap_id })
    ] })
  ] });
};
export {
  j as ProductDetails
};
